import React, { useMemo } from "react";

interface Props<T> {
  renderItem: (item: T) => JSX.Element;
  items: Array<T>;
  className?: string;
  elementKey?: string;
}

const CardsList = <T,>({
  renderItem,
  items,
  className,
  elementKey = "id",
}: Props<T>): JSX.Element => {
  const Items = useMemo(
    () =>
      items.map((item, index) =>
        React.cloneElement(renderItem(item), {
          key:
            item && typeof item === "object" && elementKey in item
              ? `${item[elementKey as keyof typeof item] as unknown as string}${index}`
              : undefined,
          className: index > 0 ? "mt-sm" : "",
        }),
      ),
    [items, renderItem, elementKey],
  );

  return <div className={className}>{Items}</div>;
};

export default CardsList;
